import { Injectable } from '@angular/core';
import { AppSettings, AsamcoAuthService } from '@asamco/base';
import { bind } from '@asamco/utils';

import { AsamcoSignalrBase } from '../asamco-signalr-base';

// Default Asamco Icon
// const DEFAULT_ICON =
// 	'https://media.licdn.com/dms/image/C560BAQFgggP8bNeKyA/company-logo_200_200/0?e=2159024400&v=beta&t=bXybCtjRPygB2J0yydY3wkpcqOe_JniT_df-oeAmqj8';

@Injectable({
	providedIn: 'root',
	deps: [AsamcoAuthService, AppSettings],
})
export class RefreshSignalrService extends AsamcoSignalrBase {
	/**
	 * Our hubname to connect to
	 */
	protected hubName = 'userSession';

	protected events = [{ methodName: 'RefreshPage', newMethod: this.refresh }];

	/**
	 *Creates an instance of RefreshSignalrService.
	 * @param {SignalR} signalr
	 * @param {AsamcoAuthService} auth
	 * @param {AppSettings} app
	 * @memberof RefreshSignalrService
	 */
	constructor(auth: AsamcoAuthService, app: AppSettings) {
		super(auth, app);
	}

	/**
	 * Called when a refresh signal is received
	 * @param not
	 */
	@bind
	private refresh() {
		location.reload();
	}
}
